import { useQuery } from "@tanstack/react-query";
import { portalApi } from "@/lib/portalApi";
import { PortalLayout } from "@/components/portal/PortalLayout";
import { ClientChat } from "@/components/portal/ClientChat";
import { MessageSquare } from "lucide-react";

export default function PortalMessages() {
  const { data: me } = useQuery({
    queryKey: ["portal", "me"],
    queryFn: () => portalApi.me(),
  });

  return (
    <PortalLayout accountName={me?.account_name}>
      <div className="space-y-6 max-w-2xl">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <MessageSquare className="w-6 h-6" />
            Messages
          </h1>
          <p className="text-muted-foreground mt-1">
            Questions about anything? Send us a message and we'll get back to you.
          </p>
        </div>
        <ClientChat />
      </div>
    </PortalLayout>
  );
}
